{
  "labels": {
    "signUp": "",
    "signIn": "",
    "paste": "Vložit",
    "pasteAsPlaintext": "Vložit jako prostý text",
    "pasteCharts": "Vložit grafy",
    "chartType_bar": "",
    "chartType_line": "",
    "chartType_radar": "",
    "chartType_plaintext": "",
    "selectAll": "Vybrat vše",
    "multiSelect": "Přidat prvek do výběru",
    "moveCanvas": "Posunout plátno",
    "cut": "Vyjmout",
    "copy": "Kopírovat",
    "copyAsPng": "Zkopírovat do schránky jako PNG",
    "copyAsSvg": "Zkopírovat do schránky jako SVG",
    "copyText": "Zkopírovat do schránky jako text",
    "copySource": "Kopírovat zdroj do schránky",
    "convertToCode": "Převést na kód",
    "bringForward": "Přenést blíž",
    "sendToBack": "Přenést do pozadí",
    "bringToFront": "Přenést do popředí",
    "sendBackward": "Přenést dál",
    "delete": "Smazat",
    "copyStyles": "Kopírovat styly",
    "pasteStyles": "Vložit styly",
    "stroke": "Obrys",
    "changeStroke": "Změnit barvu ohraničení",
    "background": "Pozadí",
    "changeBackground": "Změnit barvu pozadí",
    "fill": "Výplň",
    "strokeWidth": "Tloušťka tahu",
    "strokeStyle": "Styl tahu",
    "strokeStyle_solid": "Plný",
    "strokeStyle_dashed": "Čárkovaný",
    "strokeStyle_dotted": "Tečkovaný",
    "sloppiness": "Stylizace",
    "pressure": "",
    "pressure_constant": "",
    "pressure_variable": "",
    "opacity": "Průhlednost",
    "textAlign": "Zarovnání textu",
    "edges": "Hrany",
    "sharp": "Ostré",
    "round": "Zaoblené",
    "arrowheads": "Styl šipky",
    "arrowhead_none": "Žádný",
    "arrowhead_arrow": "Šipka",
    "arrowhead_bar": "Kóta",
    "arrowhead_circle": "Kruh",
    "arrowhead_circle_outline": "Kružnice",
    "arrowhead_triangle": "Trojúhelník",
    "arrowhead_triangle_outline": "Trojúhelník (obrys)",
    "arrowhead_diamond": "Kosočtverec",
    "arrowhead_diamond_outline": "Kosočtverec (obrys)",
    "arrowhead_crowfoot_many": "",
    "arrowhead_crowfoot_one": "",
    "arrowhead_crowfoot_one_or_many": "",
    "arrowhead_cardinality_one": "",
    "arrowhead_cardinality_many": "",
    "arrowhead_cardinality_one_or_many": "",
    "arrowhead_cardinality_exactly_one": "",
    "arrowhead_cardinality_zero_or_one": "",
    "arrowhead_cardinality_zero_or_many": "",
    "more_options": "",
    "cardinality": "",
    "arrowtypes": "Typ šipky",
    "arrowtype_sharp": "Ostrá šipka",
    "arrowtype_round": "Zakřivená šipka",
    "arrowtype_elbowed": "",
    "fontSize": "Velikost písma",
    "fontFamily": "Písmo",
    "addWatermark": "Přidat \"Vyrobeno s Excalidraw\"",
    "handDrawn": "Od ruky",
    "normal": "Normální",
    "code": "Kód",
    "small": "Malé",
    "medium": "Střední",
    "large": "Velké",
    "veryLarge": "Velmi velké",
    "solid": "Plný",
    "hachure": "Šrafování",
    "zigzag": "Klikatě",
    "crossHatch": "Křížový šrafování",
    "thin": "Tenký",
    "bold": "Tlustý",
    "left": "Vlevo",
    "center": "Na střed",
    "right": "Vpravo",
    "extraBold": "Extra tlustý",
    "architect": "Architekt",
    "artist": "Umělec",
    "cartoonist": "Kartoonista",
    "fileTitle": "Název souboru",
    "colorPicker": "Výběr barvy",
    "canvasColors": "Použito na plátně",
    "canvasBackground": "Pozadí plátna",
    "drawingCanvas": "Kreslicí plátno",
    "clearCanvas": "Vyčistit plátno",
    "layers": "Vrstvy",
    "actions": "Akce",
    "language": "Jazyk",
    "liveCollaboration": "Živá spolupráce...",
    "duplicateSelection": "Duplikovat",
    "untitled": "Bez názvu",
    "name": "Název",
    "yourName": "Vaše jméno",
    "madeWithExcalidraw": "Vytvořeno v Excalidraw",
    "group": "Sloučit výběr do skupiny",
    "ungroup": "Zrušit sloučení skupiny",
    "collaborators": "Spolupracovníci",
    "you": "",
    "toggleGrid": "Přepínač mřížky",
    "loadingScene": "Načítání scény…",
    "loadScene": "Načíst scénu ze souboru",
    "align": "Zarovnání",
    "alignTop": "Zarovnat nahoru",
    "alignBottom": "Zarovnat dolů",
    "alignLeft": "Zarovnat vlevo",
    "alignRight": "Zarovnejte vpravo",
    "centerVertically": "Vycentrovat svisle",
    "centerHorizontally": "Vycentrovat vodorovně",
    "distributeHorizontally": "Rozložit horizontálně",
    "distributeVertically": "Rozložit svisle",
    "flipHorizontal": "Převrátit vodorovně",
    "flipVertical": "Převrátit svisle",
    "viewMode": "Náhled",
    "share": "Sdílet",
    "showStroke": "Zobrazit výběr barvy",
    "showBackground": "Zobrazit výběr barev pozadí",
    "showFonts": "Zobrazit výběr písma",
    "toggleTheme": "Přepnout světlý/tmavý motiv",
    "theme": "Motiv",
    "decreaseFontSize": "Zmenšit písmo",
    "increaseFontSize": "Zvětšit písmo",
    "unbindText": "Zrušit vazbu textu",
    "bindText": "Vázat text s kontejnerem",
    "createContainerFromText": "Zabalit text do kontejneru",
    "link": {
      "edit": "Upravit odkaz",
      "editEmbed": "Upravit odkaz pro vložení",
      "create": "Přidat odkaz",
      "label": "Odkaz",
      "labelEmbed": "Odkaz & vložit",
      "empty": "Není nastaven žádný odkaz",
      "hint": "Napište nebo vložte svůj odkaz zde",
      "goToElement": "Přejít na cílový prvek"
    },
    "lineEditor": {
      "edit": "Upravit čáru",
      "editArrow": "Upravit šipku"
    },
    "polygon": {
      "breakPolygon": "",
      "convertToPolygon": ""
    },
    "elementLock": {
      "lock": "Uzamknout",
      "unlock": "Odemknout",
      "lockAll": "Uzamknout vše",
      "unlockAll": "Odemknout vše"
    },
    "sidebarLock": "Ponechat postranní panel otevřený",
    "selectAllElementsInFrame": "Vybrat všechny prvky v orámování",
    "removeAllElementsFromFrame": "Odstranit všechny prvky z orámování",
    "eyeDropper": "Vyberte barvu z plátna",
    "followUs": "Sledujte nás",
    "discordChat": "Discord chat",
    "zoomToFitViewport": "",
    "zoomToFitSelection": "Přiblížit na výběr",
    "zoomToFit": "Přiblížit na zobrazení všech prvků",
    "installPWA": "Instalovat Excalidraw lokálně (PWA)",
    "autoResize": "Povolit automatickou změnu velikosti textu",
    "imageCropping": "",
    "unCroppedDimension": "",
    "copyElementLink": "Kopírovat odkaz na objekt",
    "linkToElement": "Odkaz na objekt",
    "wrapSelectionInFrame": "",
    "tab": "",
    "shapeSwitch": "",
    "preferences": "",
    "preferences_toolLock": "",
    "boxSelectionMode": "",
    "boxSelectionContain": "",
    "boxSelectionOverlap": "",
    "arrowBinding": "",
    "midpointSnapping": ""
  },
  "elementLink": {
    "title": "Odkaz na objekt",
    "desc": "Klikněte na tvar na plátně nebo vložte odkaz.",
    "notFound": "Propojený objekt nebyl na plátně nalezen."
  },
  "search": {
    "title": "Najít na plátně",
    "noMatch": "Nebyla nalezena žádná shoda...",
    "singleResult": "výsledek",
    "multipleResults": "výsledky",
    "placeholder": "",
    "frames": "",
    "texts": ""
  },
  "buttons": {
    "clearReset": "Resetovat plátno",
    "exportJSON": "Exportovat do souboru",
    "exportImage": "Exportovat obrázek...",
    "export": "Uložit jako...",
    "copyToClipboard": "Kopírovat do schránky",
    "copyLink": "Kopírovat odkaz",
    "save": "Uložit do aktuálního souboru",
    "saveAs": "Uložit jako",
    "load": "Otevřít",
    "getShareableLink": "Získat odkaz pro sdílení",
    "close": "Zavřít",
    "selectLanguage": "Zvolit jazyk",
    "scrollBackToContent": "Přejít zpět na obsah",
    "zoomIn": "Přiblížit",
    "zoomOut": "Oddálit",
    "resetZoom": "Resetovat přiblížení",
    "menu": "Hlavní nabídka",
    "done": "Hotovo",
    "edit": "Upravit",
    "undo": "Zpět",
    "redo": "Znovu",
    "createNewRoom": "Vytvořit novou místnost",
    "fullScreen": "Celá obrazovka",
    "darkMode": "Tmavý režim",
    "lightMode": "Světlý režim",
    "systemMode": "Nastavení systému",
    "zenMode": "Zen mód",
    "objectsSnapMode": "Přichytávat k objektům",
    "exitZenMode": "Opustit zen mód",
    "cancel": "Zrušit",
    "clear": "Vyčistit",
    "remove": "Odstranit",
    "embed": "Přepínač vkládání",
    "submit": "Odeslat",
    "confirm": "Potvrdit",
    "embeddableInteractionButton": "Klikněte pro interakci"
  },
  "alerts": {
    "clearReset": "Toto vymaže celé plátno. Jste si jisti?",
    "couldNotCreateShareableLink": "Nepodařilo se vytvořit sdílitelný odkaz.",
    "couldNotCreateShareableLinkTooBig": "Nepodařilo se vytvořit sdílený odkaz: scéna je příliš velká",
    "couldNotLoadInvalidFile": "Nepodařilo se načíst neplatný soubor",
    "importBackendFailed": "Import z backendu se nezdařil.",
    "cannotExportEmptyCanvas": "Nelze exportovat prázdné plátno.",
    "couldNotCopyToClipboard": "Nelze zkopírovat do schránky.",
    "decryptFailed": "Nelze dešifrovat data.",
    "uploadedSecurly": "Nahrávání je zabezpečeno koncovým šifrováním, což znamená, že server Excalidraw ani třetí strany nemohou obsah přečíst.",
    "loadSceneOverridePrompt": "Načítání externího výkresu nahradí váš existující obsah. Přejete si pokračovat?",
    "collabStopOverridePrompt": "Zastavení relace přepíše vaše předchozí, lokálně uložené kresby. Jste si jisti?\n\n(Pokud chcete zachovat místní kresbu, jednoduše zavřete kartu prohlížeče)",
    "imageDoesNotContainScene": "Zdá se, že tento obrázek neobsahuje žádná data o scéně. Zapnuli jste při exportu vkládání scény?",
    "cannotRestoreFromImage": "Scénu nelze obnovit z tohoto souboru obrázku",
    "invalidSceneUrl": "Nelze importovat scénu z zadané URL. Je buď poškozená, nebo neobsahuje platná JSON data Excalidraw.",
    "invalidEncryptionKey": "Šifrovací klíč musí mít 22 znaků. Live spolupráce je zakázána.",
    "collabOfflineWarning": "Není k dispozici žádné internetové připojení.\nVaše změny nebudou uloženy!",
    "localStorageQuotaExceeded": ""
  },
  "errors": {
    "unsupportedFileType": "Nepodporovaný typ souboru.",
    "imageInsertError": "Nelze vložit obrázek. Zkuste to později...",
    "fileTooBig": "Soubor je příliš velký. Maximální povolená velikost je {{maxSize}}.",
    "svgImageInsertError": "Nelze vložit SVG obrázek. Značení SVG je neplatné.",
    "failedToFetchImage": "Nepodařilo se načíst obrázek.",
    "cannotResolveCollabServer": "Nelze se připojit ke sdílenému serveru. Prosím obnovte stránku a zkuste to znovu.",
    "collabSaveFailed": "Nelze uložit do databáze na serveru. Pokud problémy přetrvávají, měli byste uložit soubor lokálně, abyste se ujistili, že neztratíte svou práci.",
    "collabSaveFailed_sizeExceeded": "Nelze uložit do databáze na serveru, plátno se zdá být příliš velké. Měli byste uložit soubor lokálně, abyste se ujistili, že neztratíte svou práci.",
    "imageToolNotSupported": "Obrázky jsou vypnuty.",
    "brave_measure_text_error": {
      "line1": "Vypadá to, že používáte Brave prohlížeč s povoleným nastavením <bold>Aggressively Block Fingerprinting</bold>.",
      "line2": "To by mohlo vést k narušení <bold>Textových elementů</bold> ve vašich výkresech.",
      "line3": "Důrazně doporučujeme zakázat toto nastavení. Můžete sledovat <link>tyto kroky</link> jak to udělat.",
      "line4": "Pokud vypnutí tohoto nastavení neopravuje zobrazení textových prvků, prosím, otevřete <issueLink>problém</issueLink> na našem GitHubu, nebo nám napište na <discordLink>Discord</discordLink>"
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "Nepodařilo se vložit.",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "Výběr",
    "lasso": "",
    "image": "Vložit obrázek",
    "rectangle": "Obdélník",
    "diamond": "Diamant",
    "ellipse": "Elipsa",
    "arrow": "Šipka",
    "line": "Čára",
    "freedraw": "Kreslení",
    "text": "Text",
    "lock": "Po kreslení ponechat vybraný nástroj aktivní",
    "penMode": "Režim Pera - zabránit dotyku",
    "link": "",
    "eraser": "Guma",
    "frame": "Orámování",
    "embeddable": "Web Embed",
    "laser": "Laserové ukazovátko",
    "autoshape": "",
    "bucketfill": "",
    "hand": "Ruka (nástroj pro posouvání)",
    "extraTools": "Více nástrojů",
    "convertElementType": ""
  },
  "bucketfill": {
    "noRegion": "",
    "tooComplex": ""
  },
  "element": {
    "rectangle": "Obdélník",
    "diamond": "Kosočtverec",
    "ellipse": "Elipsa",
    "arrow": "Šipka",
    "line": "Čára",
    "freedraw": "Volné kreslení",
    "text": "Text",
    "image": "Obrázek",
    "group": "Skupina",
    "frame": "Rám",
    "embeddable": "",
    "selection": "Výběr",
    "iframe": "IFrame"
  },
  "headings": {
    "canvasActions": "Akce plátna",
    "selectedShapeActions": "Akce vybraného tvaru",
    "shapes": "Tvary"
  },
  "hints": {
    "dismissSearch": "",
    "canvasPanning": "",
    "linearElement": "Kliknutím pro více bodů, táhnutím pro jednu čáru",
    "arrowTool": "",
    "arrowBindModifiers": "",
    "freeDraw": "Klikněte a táhněte, pro ukončení pusťte",
    "text": "Tip: Text můžete také přidat dvojitým kliknutím kdekoli pomocí nástroje pro výběr",
    "embeddable": "",
    "autoshape": "",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "",
    "lockAngle": "",
    "resize": "",
    "resizeImage": "",
    "rotate": "",
    "toggleArrowhead": "",
    "lineEditor_info": "",
    "lineEditor_line_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "bindTextToElement": "",
    "createFlowchart": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "Tato funkce může být povolena nastavením vlajky \"dom.events.asyncClipboard.clipboardItem\" na \"true\". Chcete-li změnit vlajky prohlížeče ve Firefoxu, navštivte stránku \"about:config\".",
    "disableSnapping": "",
    "enterCropEditor": "",
    "leaveCropEditor": ""
  },
  "canvasError": {
    "cannotShowPreview": "Náhled nelze zobrazit",
    "canvasTooBig": "Plátno je možná příliš velké.",
    "canvasTooBigTip": "Tip: zkus posunout nejvzdálenější prvky trochu blíže k sobě."
  },
  "errorSplash": {
    "headingMain": "Chyba. Zkuste <button>znovu načíst stránku</button>.",
    "clearCanvasMessage": "Pokud opětovné načtení nefunguje, zkuste <button>vymazat plátno</button>.",
    "clearCanvasCaveat": " To povede ke ztrátě dat ",
    "trackedToSentry": "Chyba identifikátoru {{eventId}} byl zaznamenán v našem systému.",
    "openIssueMessage": "Byli jsme velmi opatrní, abychom neuváděli informace o Vaší scéně. Pokud vaše scéna není soukromá, zvažte prosím sledování na našem <button>bug trackeru</button>. Uveďte prosím níže uvedené informace kopírováním a vložením do problému na GitHubu.",
    "sceneContent": "Obsah scény:"
  },
  "shareDialog": {
    "or": ""
  },
  "roomDialog": {
    "desc_intro": "",
    "desc_privacy": "",
    "button_startSession": "Zahájit relaci",
    "button_stopSession": "Ukončit relaci",
    "desc_inProgressIntro": "Živá spolupráce právě probíhá.",
    "desc_shareLink": "Sdílejte tento odkaz s každým, s kým chcete spolupracovat:",
    "desc_exitSession": "Zastavením relace se odpojíte od místnosti, ale budete moci pokračovat v práci s touto scénou lokálně. Všimněte si, že to nebude mít vliv na ostatní lidi a budou stále moci spolupracovat na jejich verzi.",
    "shareTitle": "Připojte se k aktivní spolupráci na Excalidraw"
  },
  "errorDialog": {
    "title": "Chyba"
  },
  "progressDialog": {
    "title": "",
    "defaultMessage": ""
  },
  "exportDialog": {
    "disk_title": "Uložit na disk",
    "disk_details": "Exportovat data scény do souboru, ze kterého můžete importovat později.",
    "disk_button": "Uložit do souboru",
    "link_title": "Odkaz pro sdílení",
    "link_details": "Exportovat jako odkaz pouze pro čtení.",
    "link_button": "Exportovat do odkazu",
    "excalidrawplus_description": "Uložit scénu do vašeho pracovního prostoru Excalidraw+.",
    "excalidrawplus_button": "Exportovat",
    "excalidrawplus_exportError": "Export do Excalidraw+ se v tuto chvíli nezdařil..."
  },
  "helpDialog": {
    "blog": "Přečtěte si náš blog",
    "click": "kliknutí",
    "deepSelect": "Hluboký výběr",
    "deepBoxSelect": "Hluboký výběr uvnitř boxu a zabránění táhnnutí",
    "createFlowchart": "",
    "navigateFlowchart": "",
    "curvedArrow": "Zakřivená šipka",
    "curvedLine": "Zakřivená čára",
    "documentation": "Dokumentace",
    "doubleClick": "dvojklik",
    "drag": "tažení",
    "editor": "",
    "editLineArrowPoints": "Upravit body linií/šipek",
    "editText": "Upravit text / přidat popis",
    "github": "Našel jsi problém? Nahlaš ho",
    "howto": "Sledujte naše návody",
    "or": "nebo",
    "preventBinding": "Zabránit vázání šipky",
    "tools": "Nástroje",
    "shortcuts": "Klávesové zkratky",
    "textFinish": "Dokončit úpravy (textový editor)",
    "textNewLine": "Přidat nový řádek (textový editor)",
    "title": "Nápověda",
    "view": "Zobrazení",
    "zoomToFit": "Přiblížit na zobrazení všech prvků",
    "zoomToSelection": "Přiblížit na výběr",
    "toggleElementLock": "Zamknout/odemknout výběr",
    "movePageUpDown": "Posunout stránku nahoru/dolů",
    "movePageLeftRight": "Přesunout stránku doleva/doprava",
    "cropStart": "",
    "cropFinish": ""
  },
  "clearCanvasDialog": {
    "title": "Vymazat plátno"
  },
  "imageExportDialog": {
    "header": "Exportovat obrázek",
    "label": {
      "withBackground": "Pozadí",
      "onlySelected": "Pouze vybrané",
      "darkMode": "Tmavý režim",
      "embedScene": "Vložit scénu",
      "scale": "Měřítko",
      "padding": "Odsazení"
    },
    "tooltip": {
      "embedScene": "Data scény budou uložena do exportovaného souboru PNG/SVG tak, aby z něj mohla být scéna obnovena.\nZvýší se velikost exportovaného souboru."
    },
    "title": {
      "exportToPng": "Exportovat do PNG",
      "exportToSvg": "Exportovat do SVG",
      "copyPngToClipboard": "Kopírovat PNG do schránky"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "Kopírovat do schránky"
    }
  },
  "encrypted": {
    "tooltip": "Vaše kresby jsou end-to-end šifrované, takže servery Excalidraw je nikdy neuvidí.",
    "link": "Blog příspěvek na end-to-end šifrování v Excalidraw"
  },
  "stats": {
    "angle": "Úhel",
    "shapes": "Tvary",
    "height": "Výška",
    "scene": "Scéna",
    "selected": "Vybráno",
    "storage": "Úložiště",
    "fullTitle": "Vlastnosti plátna a tvarů",
    "title": "Vlastnosti",
    "generalStats": "Obecné",
    "elementProperties": "Vlastnosti tvaru",
    "total": "Celkem",
    "version": "Verze",
    "versionCopy": "Kliknutím zkopírujete",
    "versionNotAvailable": "Verze není k dispozici",
    "width": "Šířka"
  },
  "toast": {
    "copyStyles": "Styly byly zkopírovány.",
    "copyToClipboard": "Zkopírováno do schránky.",
    "copyToClipboardAsPng": "{{exportSelection}} zkopírován do schránky jako PNG\n({{exportColorScheme}})",
    "copyToClipboardAsSvg": "",
    "fileSaved": "Soubor byl uložen.",
    "fileSavedToFilename": "Uloženo do {filename}",
    "canvas": "plátno",
    "selection": "výběr",
    "pasteAsSingleElement": "Pomocí {{shortcut}} vložte jako jeden prvek,\nnebo vložte do existujícího textového editoru",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": "",
    "elementLinkCopied": ""
  },
  "colors": {
    "transparent": "Průhledná",
    "black": "Černá",
    "white": "Bílá",
    "red": "Červená",
    "pink": "Růžová",
    "grape": "Vínová",
    "violet": "Fialová",
    "gray": "Šedá",
    "blue": "Modrá",
    "cyan": "Azurová",
    "teal": "Modrozelená",
    "green": "Zelená",
    "yellow": "Žlutá",
    "orange": "Oranžová",
    "bronze": "Bronzová"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_line2": "",
      "center_heading_line3": "",
      "center_heading_plus": "Chcete místo toho přejít na Excalidraw+?",
      "menuHint": "Export, nastavení, jazyky, ..."
    },
    "defaults": {
      "menuHint": "Export, nastavení a další...",
      "center_heading": "Diagramy. Vytvořeny. Jednoduše.",
      "toolbarHint": "Vyberte nástroj a začněte kreslit!",
      "helpHint": "Zkratky a pomoc"
    }
  },
  "colorPicker": {
    "color": "",
    "mostUsedCustomColors": "Nejpoužívanější vlastní barvy",
    "colors": "Barvy",
    "shades": "Stíny",
    "hexCode": "Hex kód",
    "noShades": "Pro tuto barvu nejsou k dispozici žádné odstíny",
    "invalidColor": "",
    "invalidHexLength": "",
    "topPicksTip": "",
    "resetTopPicks": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "",
        "button": "",
        "description": ""
      },
      "saveToDisk": {
        "title": "",
        "button": "",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "",
        "button": "",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "Načíst ze souboru",
        "button": "Načíst ze souboru",
        "description": ""
      },
      "shareableLink": {
        "title": "Načíst z odkazu",
        "button": "Nahradit můj obsah",
        "description": ""
      }
    }
  },
  "quickSearch": {
    "placeholder": "Rychlé vyhledávání"
  },
  "fontList": {
    "badge": {
      "old": "staré"
    },
    "sceneFonts": "V této scéně",
    "availableFonts": "Dostupná písma",
    "empty": "Nebyla nalezena žádná písma"
  },
  "userList": {
    "empty": "Nebyli nalezeni žádní uživatelé",
    "hint": {
      "text": "Klikněte na uživatele pro sledování",
      "followStatus": "Právě sledujete tohoto uživatele",
      "inCall": "Uživatel je v hovoru",
      "micMuted": "Mikrofon uživatele je ztlumen",
      "isSpeaking": "Uživatel hovoří"
    }
  },
  "keys": {
    "ctrl": "",
    "option": "",
    "cmd": "",
    "alt": "",
    "escape": "",
    "enter": "",
    "shift": "",
    "spacebar": "",
    "delete": "",
    "mmb": ""
  }
}
